import { Data } from './index'

const divider = '-'
export const getKey = ({ id, __typename }: Pick<Data, 'id' | '__typename'>) =>
  [id, __typename].join(divider)
